module.exports = __webpack_public_path__ + "img/Kefalonia.e8e42b0d.png";